<script lang="ts">
  import { tick } from 'svelte';
  import type { HTMLInputAttributes } from 'svelte/elements';
  import { formatMoneyTyping } from '../lib/money-input';
  import Input from './Input.svelte';

  /**
   * A toman amount (pilot feedback #1): grouped by three with commas while typing, caret kept in
   * place. The text is read with `parseTomanInput` as before; the server checks the amount again.
   */
  let {
    value,
    onValueChange,
    allowNegative = false,
    ...rest
  }: Omit<HTMLInputAttributes, 'value' | 'type'> & {
    value: string;
    onValueChange: (text: string) => void;
    allowNegative?: boolean;
  } = $props();

  let element = $state<HTMLInputElement>();

  async function oninput(e: Event & { currentTarget: HTMLInputElement }) {
    const el = e.currentTarget;
    const next = formatMoneyTyping(el.value, el.selectionStart ?? el.value.length, allowNegative);
    onValueChange(next.text);
    // A value equal to the previous one does not re-render: write it back by hand.
    el.value = next.text;
    await tick();
    if (document.activeElement === el) el.setSelectionRange(next.caret, next.caret);
  }
</script>

<Input
  {...rest}
  bind:element
  {value}
  {oninput}
  inputmode={allowNegative ? 'text' : 'decimal'}
  dir="ltr"
  autocomplete="off"
/>
